import { PLAYER_EVENT } from '@/common/utils/player.interface'

export default {
  props: {
    contentInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isTrailerPlaying: false // 음소거 버튼을 위한 예고편 플레이어 재생 상태
    }
  },
  computed: {

  },
  methods: {
    addPlayerEventHandler () {
      this.$events.$on(PLAYER_EVENT.PLAY, (info) => {
        this.isTrailerPlaying = true
      })
      this.$events.$on(PLAYER_EVENT.END, (info) => {
        this.isTrailerPlaying = false
      })
    },
    removePlayerEventHandler () {
      this.$events.$off(PLAYER_EVENT.PLAY)
      this.$events.$off(PLAYER_EVENT.END)
    }
  },
  created () {
    this.addPlayerEventHandler()
  },
  beforeDestroy () {
    this.removePlayerEventHandler()
  }
}
